import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormHelper } from '@forms';
import { AuthService } from '@auth';
import { HttpHelperService, HttpTokenService } from '@http';
import { VerificationService } from './verification.service';
import { __i18n } from '@localisation';
import { Config } from '@config';
import { GlobalEventBus, ActionEvents } from '@event-bus';


@Component({
    selector: 'verification-code',
    templateUrl: './verification.code.template.html',
    standalone: false
})
export class VerificationCodeComponent {
    constructor(
        private formBuilder: FormBuilder,
        private formHelper: FormHelper,
        private verificationService: VerificationService,
        private httpHelper: HttpHelperService,
        private authService: AuthService,
        private config: Config,
        private eventBus: GlobalEventBus
    ) {
        this.verificationCodeForm = this.formBuilder.group({
            code: ['', Validators.required]
        });
    }

    public async verification() {
        this.formHelper.markFormGroupTouched(this.verificationCodeForm);
        if (this.verificationCodeForm.valid) {
            try {
                const result = await this.verificationService.verificate(this.verificationCodeForm.controls.code.value);
                if (result) {
                    this.config.serverConfig.VERIFICATION_CODE_REQUIRED = false;
                    this.authService.checkLoginStatus();
                }
            } catch (e) {
                this.verificationError =
                    this.httpHelper.getErrorMessage(e)
                    || __i18n('We could not verify it, an error occured.', 'landingpage.verification.error');
            }
        }
    }

    public logout() {
        this.eventBus.trigger(ActionEvents.disconnect, { force : true});
    }

    public verificationCodeForm: any;

    public verificationError: string;

    public confirmButtonState: boolean;
}